import React from 'react';
import { updatePrefillMessage, updateOptionalMessage, updateSelectedLocation, removeChip } from '../../actions/alert_actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CustomModal from './custom-modal';

class CustomForm extends React.Component {
  componentDidMount() {
    //remove ability to send message when first loaded (means no data has been entered)
    document.getElementById('customBtn').disabled = true;
  }

  componentDidUpdate() {
    //check if any employees have been selected and if a message has been selected or an optional message filled in
    //if both, allow user to send message, otherwise disable send button
    if (this.props.chips[0] && (this.props.prefillMessage || this.props.optionalMessage)) {
      document.getElementById('customBtn').disabled = false;
    } else {
      document.getElementById('customBtn').disabled = true;
    }
  }


  renderChips() {
    //render list of chips to be displayed
    return this.props.chips.map((chip) => {
      return (
        <div key={chip.id} id={chip.id} className="chip" onClick={(e) => {this.props.removeChip(e.currentTarget.id)}}>
          {chip.first} {chip.last}
          <i className="material-icons x">close</i>
        </div>
      )
    })
  }

  render() {
    const messages = {
      test: 'ALERT: This is a test alert',
      rain: 'ALERT: Work has been cancelled today due to heavy rainfall in the orchards.',
      vog : 'ALERT: Work has been cancelled today due to excessive vog/ash in the orchards.',
      lightning: 'ALERT: Work has been cancelled today due to lightning close to the orchards.',
      disaster: 'ALERT: Work has been cancelled today due to a natural disaster near the orchards.',
      threat: 'ALERT: There is an ongoing threat in the orchards.'
    }

    return (
      <div className={this.props.className}>
        <form className="messageForm">
          {/******* Select People *******/}
          <div className="input-field">
            <h6 className={this.props.chips.length > 0 ? 'hidden' : ''} id="defaultMessage">Select employees from the list to add recipients.</h6>
            {this.renderChips()}
          </div>
          {/******* Select Message *******/}
          <div className="input-field">
            <select className="browser-default" defaultValue="" id="messages" onChange={(e) => {this.props.updatePrefillMessage(e.target.value)}}>
              <option value = "" disabled>Select Message</option>
              <option value={messages.test}>Test</option>
              <option value={messages.rain}>Rain Out</option>
              <option value={messages.vog}>Vog/Ash</option>
              <option value={messages.lightning}>Lightning</option>
              <option value={messages.threat}>Threat</option>
            </select>
            <p id="selectedMessageText">{this.props.prefillMessage}</p>
          </div>
          {/******* Enter Message *******/}
          <div className="input-field">
            <label htmlFor='messageInput'>
              Optional additional information
            </label>
            <input
              onChange= {(e) => {this.props.updateOptionalMessage(e.target.value)}}
              className="validate"
              id='messageInput'
              type='text'
            />
          </div>
          <button id="customBtn" data-target="CustomModal" className="btn modal-trigger modalBtn">Send Message</button>
        </form>
        <CustomModal id="CustomModal"/>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    prefillMessage: state.form.prefillMessage,
    optionalMessage: state.form.optionalMessage,
    chips: state.form.chips
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updatePrefillMessage,
    updateOptionalMessage,
    updateSelectedLocation,
    removeChip
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomForm);



// WEBPACK FOOTER //
// ./src/components/alert/custom-form.js